/**
 * @generated SignedSource<<6f46b3fd13c84a83cac38302abaf87f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRealtimeUpdater953BadPattern$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraSpreadsheetGroupEdge";
  } | null | undefined> | null | undefined;
  readonly groupByField: string | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "IssueRealtimeUpdater953BadPattern";
};
export type IssueRealtimeUpdater953BadPattern$key = {
  readonly " $data"?: IssueRealtimeUpdater953BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater953BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueRealtimeUpdater953BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "92ac0002b5c796135afc46ab012d8b73";

export default node;
